import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Divider, Typography, useTheme, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ROUTES from "config/routes";

const useStyles = makeStyles((theme) => ({
  mainContent: {
    width: "100%",
    [theme.breakpoints.up("tablet")]: {
      borderLeft: (props) => (props.showDivider ? `1px solid ${theme.palette.divider}` : "none"),
      margin: "16px 0",
    },
    padding: "16px 24px",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    justifyContent: "center",
  },
  joinButton: {
    maxWidth: "fit-content",
  },
}));

export default function JoinNowMemberCard(props) {
  const MEMBERSHIP_NAME = process.env.REACT_APP_MOLLIES_MEMBER_TITLE || "";
  const classes = useStyles(props);
  const theme = useTheme();

  const tabletUpScreen = useMediaQuery(theme.breakpoints.up(theme.breakpoints.values.tablet));

  return (
    <div className={classes.mainContent}>
      {!tabletUpScreen && <Divider />}
      <Typography>{`Not a member of ${MEMBERSHIP_NAME}?`}</Typography>
      <Typography variant="body2">
        {`Members get access to exclusive rates and special perks. It’s free to join and only takes a moment.`}
      </Typography>
      <Button
        className={classes.joinButton}
        variant="contained"
        color="secondary"
        component={Link}
        to={props.isAuthPopup ? ROUTES.AUTH_POPUP : ROUTES.SIGNUP}
        disableElevation>
        Join now
      </Button>
    </div>
  );
}

JoinNowMemberCard.propTypes = {
  showDivider: PropTypes.bool,
  isAuthPopup: PropTypes.bool,
};
JoinNowMemberCard.defaultProps = {
  showDivider: false,
  isAuthPopup: false,
};
